<script setup lang="ts">
import { toRefs } from 'vue';
import ChartLegendItem, { ChartLegendItemPropsInterface } from './ChartLegendItem.vue';

interface LegendPropsInterface {
  labels: ChartLegendItemPropsInterface[];
}
const props = defineProps<LegendPropsInterface>();
const { labels } = toRefs(props);
</script>

<template>
  <div class="col inline-grid">
    <ChartLegendItem
      v-for="label of labels"
      :key="label.color"
      :title="label.title"
      :total="label.total"
      :color="label.color"
    />
  </div>
</template>
